<template>
  <div
    class="fixed inset-0 z-50 flex items-start px-4 py-6 pointer-events-none sm:p-6"
  >
    <transition-group
      class="w-full max-w-sm"
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="translate-x-4 opacity-0"
      enter-to-class="translate-x-0 opacity-100"
      leave-active-class="transition duration-100 ease-in"
      leave-class="opactity-100"
      leave-to-class="opacity-0"
      tag="ul"
      move-class="transition duration-500 ease-in-out"
    >
      <PNotification @close="remove" v-for="notification in notifications" :notification="notification" :duration="duration" :key="notification.id" />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PNotification from "@/components/PNotification";

export default {
  name: "PNotifications",
  props: {
    duration: {
      type: Number,
      default: 10000
    },
  },
  computed: {
    ...mapGetters (
      ["notifications"]
    ),
    ...mapMutations (
      ["removeNotification"]
    )
  },
  components: {
    PNotification
  },
  methods: {
    remove (notification) {
      this.$store.commit("removeNotification", notification)
    }
  }
}
</script>
